import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

export default function UpdateModal({ open, onConfirm }) {
	return (
		<Modal
			open={open}
			aria-labelledby="update-modal-title"
			aria-describedby="update-modal-description"
			disableEscapeKeyDown
			disableAutoFocus
			disableEnforceFocus
			sx={{
				backdropFilter: 'blur(4px)',
				backgroundColor: 'rgba(0,0,0,0.7)' // fondo oscurito
			}}
		>
			<Box
				sx={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					bgcolor: '#1e1e1e',
					color: 'white',
					borderRadius: 3,
					boxShadow: 24,
					p: 4,
					width: '90%',
					maxWidth: 400,
					textAlign: 'center',
					border: '1px solid #333'
				}}
			>
				<Typography id="update-modal-title" variant="h5" fontWeight="bold">
					Nueva versión disponible
				</Typography>

				<Typography id="update-modal-description" sx={{ mt: 2, opacity: 0.9 }}>
					Para seguir usando la aplicación necesitas actualizar a la última versión.
				</Typography>

				<Button
					variant="contained"
					color="primary"
					size="large"
					sx={{
						mt: 4,
						borderRadius: '10px',
						paddingX: 4,
						textTransform: 'none',
						fontSize: '1rem'
					}}
					onClick={onConfirm}
				>
					Actualizar ahora
				</Button>
			</Box>
		</Modal>
	);
}
